
































import { Component, Vue, Ref } from 'vue-property-decorator';
import { generateOptionsByKey, permissionManage } from './permission';
import PermissionModal from './components/permissionModal.vue';

type IPermissionInfo = IPermission.IResponse.IPermissionInfo;

const nameColumn = {
  slots: { title: 'nameTit' },
  dataIndex: 'name',
  width: '15%',
};
const commentColumn = {
  slots: { title: 'commentTit' },
  dataIndex: 'comment',
  ellipsis: true,
  width: '15%',
};
const roleColumn = {
  slots: { title: 'roleTit' },
  dataIndex: 'roles',
  scopedSlots: { customRender: 'role'},
  width: '30%',
};
const userColumn = {
  slots: { title: 'userTit' },
  dataIndex: 'user',
  scopedSlots: { customRender: 'user'},
  width: '30%',
};

@Component({
  name: 'Permission',
  components: {
    PermissionModal,
  },
})
export default class Permission extends Vue {
  @Ref() private readonly permissionModal!: PermissionModal;
  private permissionManage = permissionManage;
  private pagination = {
    hideOnSinglePage: true,
  };
  private spinning = false;
  get permissionList() {
    return this.permissionManage.data;
  }
  get columns() {
    const groupNameColumn = {
      slots: { title: 'groupNameTit' },
      dataIndex: 'groupName',
      width: '10%',
      filters: generateOptionsByKey(this.permissionList, 'groupName', 'groupName'),
      onFilter: (value: string, record: IPermissionInfo) => {
        return record.groupName === value;
      },
    };
    return [
      groupNameColumn,
      nameColumn,
      commentColumn,
      roleColumn,
      userColumn,
    ];
  }
  private created() {
    this.refreshPermissions();
  }
  private destroyed() {
    permissionManage.clearData();
  }
  private refreshPermissions() {
    this.spinning = true;
    permissionManage.requestGetPermissions().then((res) => {
      this.spinning = false;
    }).catch((err) => {
      this.$message.warning(err);
      this.spinning = false;
    });
  }
  private editUsers(permission: IPermissionInfo, type: 'add'| 'del') {
    permissionManage.editPermission(permission);
    this.permissionModal.showModal('edit-users', type);
  }
  private editRoles(permission: IPermissionInfo, type: 'add'| 'del') {
    permissionManage.editPermission(permission);
    this.permissionModal.showModal('edit-roles', type);
  }
}
